import { render, staticRenderFns } from "./StaticPageEditor.vue?vue&type=template&id=79c90de0"
import script from "./StaticPageEditor.vue?vue&type=script&lang=js"
export * from "./StaticPageEditor.vue?vue&type=script&lang=js"
import style0 from "./StaticPageEditor.vue?vue&type=style&index=0&id=79c90de0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports